"use client";

import PageBackTitle from "../Component/PageBackTitle";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  CircularProgress,
  Snackbar,
  Alert as MuiAlert,
} from "@mui/material";
import Select from "react-select";
import axios from "axios";
import API_URL from "../../src/Config";

function Form2({
  isSidebarExpanded,
  permit_id,
  permit_type_id,
  fetchComplitionSatusData,
}) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [checklistItems, setChecklistItems] = useState({});
  const [status, setStatus] = useState({});
  const [dropdownValue, setDropdownValue] = useState({});
  const [inputValue, setInputValue] = useState({});
  const [additionalInputFields, setAdditionalInputFields] = useState({});
  const [additionalInputValues, setAdditionalInputValues] = useState({});
  const [additionalDropdownFields, setAdditionalDropdownFields] = useState({});
  const [additionalDropdownValues, setAdditionalDropdownValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isNewChecklist, setIsNewChecklist] = useState(false);

  const equipmentOptions = [
    { value: "blinded", label: "Blinded" },
    { value: "connected", label: "Connected" },
    { value: "closed", label: "Closed" },
    { value: "isolated", label: "Isolated" },
    { value: "wedgeopened", label: "Wedge Opened" },
  ];

  const handleAdditionalDropdownChange = (itemId, fieldId, selectedOption) => {
    console.log("selectedOption cccc", selectedOption);
    setAdditionalDropdownValues((prev) => ({
      ...prev,
      [itemId]: { ...prev[itemId], [fieldId]: selectedOption },
    }));
  };

  const handleAdditionalInputChange = (itemId, fieldId, value) => {
    console.log("Additional input change:", { itemId, fieldId, value });
    setAdditionalInputValues((prev) => ({
      ...prev,
      [itemId]: { ...prev[itemId], [fieldId]: value },
    }));
  };

  const handleRadioChange = async (itemId, value) => {
    setStatus((prevState) => ({
      ...prevState,
      [itemId]: value,
    }));

    const item = findItemById(itemId);
    if (!item) return;

    // If marked "done" AND has input or dropdown, fetch dynamic fields
    if (value === "done" && (item.has_input === 1 || item.has_dropdown === 1)) {
      await fetchAdditionalInputFields(itemId);
    }
  };

  const handleCancelClick = () => navigate("/cold-work-permit");

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, type = "success") => {
    setSnackbarMessage(message);
    setSeverity(type);
    setSnackbarOpen(true);
  };

  const findItemById = (itemId) => {
    console.log("checklistItems", checklistItems);
    for (const cat of Object.values(checklistItems)) {
      const found = cat.find(
        (item) => item.id === itemId || item.checklist_item_id === itemId
      );
      if (found) return found;
    }
    return null;
  };

  const fetchAdditionalInputFields = async (itemId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const item = findItemById(itemId);
      if (!item) return;

      const checklistDescId = item.checklist_item_id || item.id;
      const response = await axios.get(
        `${API_URL}/api/permit_checklist_input_fields/${checklistDescId}`,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.data && response.data.fields) {
        const textFields = response.data.fields.filter(
          (f) => f.field_type === "text"
        );
        const dropdownFields = response.data.fields.filter(
          (f) => f.field_type === "dropdown"
        );

        setAdditionalInputFields((prevState) => ({
          ...prevState,
          [itemId]: textFields,
        }));

        setAdditionalDropdownFields((prevState) => ({
          ...prevState,
          [itemId]: dropdownFields,
        }));
      }
    } catch (error) {
      console.error("Error fetching additional input fields:", error);
      showSnackbar("Failed to load additional input fields", "error");
    }
  };

  // New function to process existing input fields from the API response
  const processExistingInputFields = (item) => {
    if (!item.input_fields || item.input_fields.length === 0) return;

    const textFields = item.input_fields.filter((f) => f.field_type === "text");
    const dropdownFields = item.input_fields.filter(
      (f) => f.field_type === "dropdown"
    );

    // Set the field definitions
    if (textFields.length > 0) {
      setAdditionalInputFields((prevState) => ({
        ...prevState,
        [item.id]: textFields,
      }));

      // Set the existing values for text fields
      const textValues = {};
      textFields.forEach((field) => {
        if (field.value) {
          textValues[field.field_label] = field.value;
        }
      });

      if (Object.keys(textValues).length > 0) {
        setAdditionalInputValues((prevState) => ({
          ...prevState,
          [item.id]: textValues,
        }));
      }
    }

    if (dropdownFields.length > 0) {
      setAdditionalDropdownFields((prevState) => ({
        ...prevState,
        [item.id]: dropdownFields,
      }));

      // Set the existing values for dropdown fields
      const dropdownValues = {};
      dropdownFields.forEach((field) => {
        if (field.value) {
          // Handle multiple values (comma-separated)
          if (field.is_multiple) {
            const values = field.value
              .split(", ")
              .map((val) => ({ value: val, label: val }));
            dropdownValues[field.field_label] = values;
          } else {
            dropdownValues[field.field_label] = {
              value: field.value,
              label: field.value,
            };
          }
        }
      });

      if (Object.keys(dropdownValues).length > 0) {
        setAdditionalDropdownValues((prevState) => ({
          ...prevState,
          [item.id]: dropdownValues,
        }));
      }
    }
  };

  const fetchChecklist = async () => {
    try {
      setIsInitialLoading(true);
      const authKey = localStorage.getItem("authKey");
      const res = await axios.get(
        `${API_URL}/api/get_permit_checklist_items?permit_id=${permit_id}&identifier=${"issuer"}`,
        {
          headers: { Authorization: authKey },
        }
      );

      console.log("res.data.checklistItems", res.data.checklistItems);
      if (res.data.checklistItems) {
        processChecklist(res.data.checklistItems);
      } else {
        const fallback = await axios.get(
          `${API_URL}/api/get_checklist_item_descriptions?identifier=${"issuer"}`,
          {
            params: { permit_type_id },
            headers: { Authorization: authKey },
          }
        );
        console.log(
          "res.data.fallback.data.checklistItems",
          fallback.data.checklistItems
        );
        processChecklist(fallback.data.checklistItems, true);
        setIsNewChecklist(true);
      }
    } catch (e) {
      console.error(e);
      setError("Failed to load checklist items");
      showSnackbar("Failed to load checklist items", "error");
    } finally {
      setIsInitialLoading(false);
    }
  };

  const processChecklist = (items, isNew = false) => {
    console.log("processChecklist items", items);
    const s = {},
      d = {},
      i = {};

    Object.values(items).forEach((arr) =>
      arr.forEach((item) => {
        s[item.id] = isNew
          ? "not-required"
          : item.status === 1
          ? "done"
          : "not-required";

        if (item.has_dropdown && item.equipment_status) {
          d[item.id] = {
            value: item.equipment_status,
            label: item.equipment_status,
          };
        }

        if (item.has_input && item.permit_no) {
          i[item.id] = item.permit_no;
        }

        // Process existing input fields for items that are already "done"
        if (
          !isNew &&
          item.status === 1 &&
          (item.has_input === 1 || item.has_dropdown === 1)
        ) {
          processExistingInputFields(item);
        }
      })
    );

    setChecklistItems(items);
    setStatus(s);
    setDropdownValue(d);
    setInputValue(i);
  };

  const validateForm = () => {
    console.log("checklistItems", checklistItems);
    const errs = [];
    Object.values(checklistItems)
      .flat()
      .forEach((item) => {
        if (status[item.id] === "done") {
          // Validate additional input fields
          if (additionalInputFields[item.id]) {
            additionalInputFields[item.id].forEach((f) => {
              const val = additionalInputValues[item.id]?.[f.field_label];
              if (f.is_required && (!val || val.trim() === ""))
                errs.push(f.field_label || f.placeholder);
            });
          }
          // Validate additional dropdown fields
          if (additionalDropdownFields[item.id]) {
            additionalDropdownFields[item.id].forEach((f) => {
              console.log("ff", f);
              const val = additionalDropdownValues[item.id]?.[f.field_label];
              if (f.is_required && !val)
                errs.push(f.field_label || f.placeholder);
            });
          }
        }
      });
    return errs;
  };

  const handleSaveClick = async () => {
    setIsLoading(true);
    const errs = validateForm();
    if (errs.length) {
      showSnackbar(`Please complete: ${errs.join(", ")}`, "error");
      setIsLoading(false);
      return;
    }

    try {
      const items = Object.values(checklistItems)
        .flat()
        .map((item) => {
          const item_id = item.id;
          const checklist_item_id = item.checklist_item_id || item.id;
          const statusValue = status[item.id] === "done" ? 1 : 0;
          const permit_no = inputValue[item.id] || "";

          const baseItem = {
            item_id,
            checklist_item_id,
            status: statusValue,
            permit_no,
          };

          // Add known static input fields from additional input values
          [
            "h2s_gas",
            "o2_gas",
            "vehicle_regd_no",
            "hc_gas",
            "lel_gas",
            "toxic_gases",
            "electrical_permit_no",
            "equipment_status",
            "permit_no",
          ].forEach((field) => {
            const value = additionalInputValues[item.id]?.[field];
            if (value !== undefined && value !== "") {
              baseItem[field] = value;
            }
          });

          // Add dynamic input fields (text fields)
          const dynamicInputFields = additionalInputFields[item.id] || [];
          dynamicInputFields.forEach((fieldMeta) => {
            const fieldName = fieldMeta.field_label || fieldMeta.field_name;
            const inputVal =
              additionalInputValues[item.id]?.[fieldMeta.field_label];
            if (
              inputVal !== undefined &&
              inputVal !== "" &&
              !baseItem[fieldName]
            ) {
              baseItem[fieldName] = inputVal;
            }
          });

          // Add dynamic dropdown fields
          const dynamicDropdownFields = additionalDropdownFields[item.id] || [];
          dynamicDropdownFields.forEach((fieldMeta) => {
            const fieldName = fieldMeta.field_label || fieldMeta.field_name;
            const dropdownVal =
              additionalDropdownValues[item.id]?.[fieldMeta.field_label];
            if (dropdownVal && !baseItem[fieldName]) {
              // Handle both single and multi-select dropdowns
              if (fieldMeta.is_multiple && Array.isArray(dropdownVal)) {
                baseItem[fieldName] = dropdownVal
                  .map((opt) => opt.value)
                  .join(", ");
              } else if (dropdownVal.value) {
                baseItem[fieldName] = dropdownVal.value;
              }
            }
          });

          return baseItem;
        });

      const authKey = localStorage.getItem("authKey");
      const payload = {
        permit_id,
        items,
      };

      if (isNewChecklist) {
        await axios.post(`${API_URL}/api/add_permit_checklist_items`, payload, {
          headers: { Authorization: authKey },
        });
      } else {
        await axios.put(
          `${API_URL}/api/update_permit_checklist_items`,
          payload,
          {
            headers: { Authorization: authKey },
          }
        );
      }

      fetchComplitionSatusData && fetchComplitionSatusData();
      setSeverity("success");
      setTimeout(() => {
        navigate(
          `/cold-work-permit-form/${permit_id}/${permit_type_id}?tab=Hazards Precautions`
        );
      });
    } catch (error) {
      console.error("Error saving checklist items:", error);
      showSnackbar("Failed to save checklist items", "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (permit_id || permit_type_id) fetchChecklist();
  }, [permit_id, permit_type_id]);

  return (
    <>
      <div className="data-form-content">
        <div className="data-form-header">
          <div className="data-form-header-content">
            <PageBackTitle className="data-form-heading-content-left-side">New Work Permit</PageBackTitle>
          </div>
        </div>
        <Divider />
        <div className="data-form-body-permit">
          <form className="form-detail" onSubmit={(e) => e.preventDefault()}>
            <div className="new-data-form">
              <Typography
                variant="h6"
                component="h3"
                className="line2"
                sx={{ mb: 3 }}
              >
                THE FOLLOWING ITEMS SHALL BE CHECKED BEFORE USING THE PERMIT
              </Typography>
              <div className="checklist-container">
                {Object.keys(checklistItems).map((category) => (
                  <Card
                    key={category}
                    className="category-section"
                    sx={{ mb: 3 }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        component="h3"
                        sx={{ mb: 2, color: "primary.main" }}
                      >
                        {category}
                      </Typography>
                      {checklistItems[category].map((item) => (
                        <Box
                          key={item.id}
                          className="checklist-item"
                          sx={{
                            mb: 3,
                            p: 2,
                            border: "1px solid #e0e0e0",
                            borderRadius: 1,
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ mb: 1, fontWeight: "medium" }}
                          >
                            ({item.item_number}) {item.description}
                          </Typography>
                          <FormControl component="fieldset">
                            <RadioGroup
                              row
                              value={status[item.id] || "not-required"}
                              onChange={(e) =>
                                handleRadioChange(item.id, e.target.value)
                              }
                            >
                              <FormControlLabel
                                value="done"
                                control={<Radio />}
                                label="Done"
                              />
                              <FormControlLabel
                                value="not-required"
                                control={<Radio />}
                                label="Not Required"
                              />
                            </RadioGroup>
                          </FormControl>

                          {/* Additional Text Input Fields */}
                          {additionalInputFields[item.id] &&
                            status[item.id] === "done" && (
                              <Box sx={{ mt: 2 }}>
                                {additionalInputFields[item.id].map(
                                  (field, index) => (
                                    <Box
                                      key={`input-${field.field_label}`}
                                      sx={{ mb: 2 }}
                                    >
                                      <TextField
                                        fullWidth
                                        label={
                                          <>
                                            {field.field_name ||
                                              field.placeholder}
                                            {/* {field.is_required} */}
                                          </>
                                        }
                                        placeholder={field.placeholder}
                                        value={
                                          additionalInputValues[item.id]?.[
                                            field.field_label
                                          ] || ""
                                        }
                                        onChange={(e) =>
                                          handleAdditionalInputChange(
                                            item.id,
                                            field.field_label,
                                            e.target.value
                                          )
                                        }
                                        variant="outlined"
                                        size="small"
                                        required={field.is_required}
                                        multiline={field.is_multiline}
                                        rows={field.is_multiline ? 3 : 1}
                                      />
                                    </Box>
                                  )
                                )}
                              </Box>
                            )}

                          {/* Additional Dropdown Fields */}
                          {additionalDropdownFields[item.id] &&
                            status[item.id] === "done" && (
                              <Box sx={{ mt: 2 }}>
                                {additionalDropdownFields[item.id].map(
                                  (field, index) => {
                                    const options =
                                      field.options?.map((option) => ({
                                        value: option,
                                        label: option,
                                      })) || [];

                                    return (
                                      <Box
                                        key={`dropdown-${field.field_label}-${index}`}
                                        sx={{ mb: 2 }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          sx={{ mb: 1 }}
                                        >
                                          {field.field_name ||
                                            field.placeholder}
                                          :{/* {field.is_required} */}
                                        </Typography>
                                        <Select
                                          value={
                                            additionalDropdownValues[item.id]?.[
                                              field.field_label
                                            ] || null
                                          }
                                          onChange={(option) =>
                                            handleAdditionalDropdownChange(
                                              item.id,
                                              field.field_label,
                                              option
                                            )
                                          }
                                          options={options}
                                          isClearable
                                          placeholder={field.placeholder}
                                          className="additional-dropdown-select"
                                          isMulti={field.is_multiple}
                                        />
                                      </Box>
                                    );
                                  }
                                )}
                              </Box>
                            )}
                        </Box>
                      ))}
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </form>
        </div>
        <div className="footer">
          <div className="button-group">
            <button
              className="data-form-cancel-button"
              onClick={handleCancelClick}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className="data-form-next-button"
              onClick={handleSaveClick}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Next"
              )}
            </button>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={severity}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default Form2;

// ------ old ------

// import React, { useState, useEffect } from "react";
// import "./Form.css";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import API_URL from "../../src/Config";
// import Select from "react-select";

// function Form2({ isSidebarExpanded, permit_id, permit_type_id, fetchComplitionSatusData }) {
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();
//   const { id } = useParams();
//   // const { permit_type_id } = useParams();

//   console.log("id", id);
//   const [checklistItems, setChecklistItems] = useState([]);
//   const [status, setStatus] = useState({});

//   const [dropdownValue, setDropdownValue] = useState({});
//   const [inputValue, setInputValue] = useState({});

//   const handleDropdownChange = (id, value) => {
//     setDropdownValue((prevState) => ({
//       ...prevState,
//       [id]: value,
//     }));
//   };

//   const handleInputChange = (id, value) => {
//     setInputValue((prevState) => ({
//       ...prevState,
//       [id]: value,
//     }));
//   };
//   const handleCancelClick = () => {
//     // navigate(`/cold-work-permit-form/${id}?tab=Work Permit Details`);
//     navigate("/cold-work-permit");
//   };

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const showSnackbar = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarOpen(true);
//   };

//   const handleRadioChange = (itemId, value) => {
//     setStatus((prevState) => ({
//       ...prevState,
//       [itemId]: value,
//     }));
//   };

//   useEffect(() => {
//     const fetchPermitDetailsItem = async () => {
//       try {
//         const authKey = localStorage.getItem("authKey");

//         const response = await axios.get(
//           `${API_URL}/api/get_permit_checklist_items?permit_id=${permit_id}`,
//           {
//             headers: {
//               Authorization: authKey,
//             },
//           }
//         );

//         const checklistItemsFromAPI = response.data.checklistItems;

//         // If response is null, call fetchPermitDetails instead
//         if (!checklistItemsFromAPI) {
//           fetchPermitDetails();
//           return;
//         }

//         // Process checklist data and store initial status, dropdown values, and input values
//         const initialStatus = {};
//         const initialDropdownValues = {};
//         const initialInputValues = {};

//         // Iterate over categories and then checklist items
//         Object.keys(checklistItemsFromAPI).forEach((category) => {
//           checklistItemsFromAPI[category].forEach((item) => {
//             initialStatus[item.id] =
//               item.status === 1 ? "done" : "not-required";

//             // Store equipment_status if dropdown exists
//             if (item.has_dropdown === 1) {
//               initialDropdownValues[item.id] = item.equipment_status
//                 ? { value: item.equipment_status, label: item.equipment_status }
//                 : null;
//             }

//             // Store permit_no if input field exists
//             if (item.has_input === 1) {
//               initialInputValues[item.id] = item.permit_no || "";
//             }
//           });
//         });

//         setChecklistItems(checklistItemsFromAPI); // Store the correctly structured response
//         setStatus(initialStatus);
//         setDropdownValue(initialDropdownValues);
//         setInputValue(initialInputValues);
//       } catch (error) {
//         console.error("Error fetching permit checklist items:", error);
//       }
//     };

//     const fetchPermitDetails = async () => {
//       try {
//         const authKey = localStorage.getItem("authKey");

//         if (!permit_type_id) {
//           console.error("Permit Type ID is missing");
//           return;
//         }

//         const response = await axios.get(
//           `${API_URL}/api/get_checklist_item_descriptions`,
//           {
//             params: { permit_type_id },
//             headers: {
//               Authorization: authKey,
//             },
//           }
//         );

//         const checklistItemsFromAPI = response.data.checklistItems || {};

//         // Initialize states for status, dropdown, and input
//         const initialStatus = {};
//         const initialDropdownValues = {};
//         const initialInputValues = {};

//         Object.values(checklistItemsFromAPI)
//           .flat()
//           .forEach((item) => {
//             initialStatus[item.id] = "not-required";

//             if (item.has_dropdown === 1) {
//               initialDropdownValues[item.id] = null;
//             }

//             if (item.has_input === 1) {
//               initialInputValues[item.id] = "";
//             }
//           });

//         setChecklistItems(checklistItemsFromAPI);
//         setStatus(initialStatus);
//         setDropdownValue(initialDropdownValues);
//         setInputValue(initialInputValues);
//         console.error(
//           "check list items:",
//           checklistItems ? checklistItems : "no"
//         );
//       } catch (error) {
//         console.error("Error fetching permit details:", error);
//       }
//     };

//     fetchPermitDetailsItem();
//   }, [id, permit_type_id, API_URL]);

//   const handleSaveClick = async () => {
//     setIsLoading(true);

//     // Ensure checklistItems is an array
//     const itemsArray =
//       checklistItems && typeof checklistItems === "object"
//         ? Object.values(checklistItems).flat() // Convert object to array
//         : [];

//     if (!Array.isArray(itemsArray)) {
//       console.error("Error: checklistItems is not an array", checklistItems);
//       setIsLoading(false);
//       return;
//     }

//     // Prepare payload for "add" API
//     const addItems = itemsArray.map((item) => ({
//       checklist_item_id: item.id, // For add, use item.id (new items)
//       status: status[item.id] === "done" ? 1 : 0,
//       permit_no: item.item_number === 5 ? inputValue[item.id] || "" : "",
//       h2s_gas: "",
//       o2s_gas: "",
//       vehicle_regd_no: "",
//       hc_gas: "",
//       lel_gas: "",
//       toxic_gases: "",
//       equipment_status:
//         item.item_number === 3 ? dropdownValue[item.id]?.value || "" : "",
//     }));

//     // Prepare payload for "update" API
//     const updateItems = itemsArray.map((item) => ({
//       checklist_item_id: item.checklist_item_id || item.id, // Use checklist_item_id if available
//       item_id: item.id, // Original item ID
//       status: status[item.id] === "done" ? 1 : 0,
//       permit_no: item.item_number === 5 ? inputValue[item.id] || "" : "",
//       h2s_gas: "",
//       o2s_gas: "",
//       vehicle_regd_no: "",
//       hc_gas: "",
//       lel_gas: "",
//       toxic_gases: "",
//       equipment_status:
//         item.item_number === 3 ? dropdownValue[item.id]?.value || "" : "",
//     }));

//     // const permit_id = permit_type_id;
//     const payload = { permit_id };

//     try {
//       const authKey = localStorage.getItem("authKey");

//       let response;
//       const isUpdate = itemsArray.some((item) => item.checklist_item_id);

//       if (isUpdate) {
//         // Update API Call
//         response = await axios.put(
//           `${API_URL}/api/update_permit_checklist_items`,
//           { ...payload, items: updateItems },
//           { headers: { Authorization: authKey } }
//         );
//       } else {
//         // Add API Call
//         response = await axios.post(
//           `${API_URL}/api/add_permit_checklist_items`,
//           { ...payload, items: addItems },
//           { headers: { Authorization: authKey } }
//         );
//       }

//       if (response.status === 200) {
//         setSeverity("success");
//         showSnackbar(
//           isUpdate
//             ? "Permit checklist updated successfully"
//             : "Permit checklist added successfully"
//         );

//         setTimeout(() => {
//           navigate(
//             `/cold-work-permit-form/${permit_id}/${permit_type_id}?tab=Hazards Precautions`
//           );
//         }, 1000);
//       }
//     } catch (error) {
//       console.error("Error saving checklist:", error);
//       setSeverity("error");
//       showSnackbar("Failed to save checklist items");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="data-form-content">
//         <div className="data-form-header">
//           <div className="data-form-header-content">
//             <PageBackTitle className="data-form-heading-content-left-side">//               New Cold Work Permit
//</PageBackTitle>
//             <div className="data-form-heading-content-right-side"></div>
//           </div>
//         </div>
//         <div className="header-separator"></div>
//         <div className="data-form-body-permit">
//           <form className="form-detail">
//             <div className="new-data-form">
//               <h3 className="line2">
//                 THE FOLLOWING ITEMS SHALL BE CHECKED BEFORE USING THE PERMIT
//               </h3>
//               <div className="checklist-container">
//                 <div>
//                   <div>
//                     {Object.keys(checklistItems).map((category) => (
//                       <div key={category} className="category-section">
//                         <h3>{category}</h3>
//                         {checklistItems[category].map((item) => (
//                           <div key={item.id} className="checklist-item">
//                             <p>
//                               ({item.item_number}) {item.description}
//                             </p>
//                             <div className="radio-buttons">
//                               <label>
//                                 <input
//                                   type="radio"
//                                   name={`item-${item.id}`}
//                                   value="done"
//                                   checked={status[item.id] === "done"}
//                                   onChange={() =>
//                                     handleRadioChange(item.id, "done")
//                                   }
//                                 />
//                                 Done
//                               </label>
//                               <label>
//                                 <input
//                                   type="radio"
//                                   name={`item-${item.id}`}
//                                   value="not-required"
//                                   checked={status[item.id] === "not-required"}
//                                   onChange={() =>
//                                     handleRadioChange(item.id, "not-required")
//                                   }
//                                 />
//                                 Not Required
//                               </label>
//                             </div>
//                             {item.has_dropdown === 1 &&
//                               status[item.id] === "done" && (
//                                 <div className="dropdowns">
//                                   <label htmlFor={`dropdown-${item.id}`}>
//                                     Select an equipment:
//                                   </label>
//                                   <Select
//                                     id={`dropdown-${item.id}`}
//                                     value={dropdownValue[item.id] || null}
//                                     onChange={(selectedOption) =>
//                                       handleDropdownChange(
//                                         item.id,
//                                         selectedOption
//                                       )
//                                     }
//                                     options={[
//                                       { value: "blinded", label: "Blinded" },
//                                       {
//                                         value: "connected",
//                                         label: "Connected",
//                                       },
//                                       { value: "closed", label: "Closed" },
//                                       { value: "isolated", label: "Isolated" },
//                                       {
//                                         value: "wedgeopened",
//                                         label: "Wedge Opened",
//                                       },
//                                     ]}
//                                     isClearable
//                                     placeholder="Select an equipment"
//                                   />
//                                 </div>
//                               )}
// {item.has_input === 1 &&
//   status[item.id] === "done" && (
//     <div className="input-field">
//       <label htmlFor={`input-${item.id}`}>
//         Permit No:
//       </label>
//       <input
//         type="text"
//         id={`input-${item.id}`}
//         value={inputValue[item.id] || ""}
//         placeholder="Enter permit no"
//         onChange={(e) =>
//           handleInputChange(item.id, e.target.value)
//         }
//       />
//     </div>
//   )}
//                           </div>
//                         ))}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </div>
//         <div className="footer">
//           <div className="button-group">
//             <button
//               className="data-form-cancel-button"
//               onClick={handleCancelClick}
//             >
//               Cancel
//             </button>
//             <button className="data-form-next-button" onClick={handleSaveClick}>
//               Next
//             </button>
//           </div>
//         </div>
//       </div>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000} // Converted to milliseconds
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default Form2;
